import React, { Suspense, useEffect, useState } from "react"
import { APIProvider } from "@vis.gl/react-google-maps"
import { env } from "../env"
import { Outlet } from "react-router-dom"
import { authAtom, setCurrentReportId, setKey, tryToTruncateUnusedReports } from "@/state/auth"
import { useAtom } from "jotai"
import { Path, useNavigate, useParams } from "@/router"
import { useCreateReport, useGetReport } from "@/queries/useReport"
import { LoadingScreen } from "@/components/screens/LoadingScreen"

export default function Layout() {
	const [auth, setAuth] = useAtom(authAtom)
	const navigate = useNavigate()
	const { refetch: fetchReport } = useGetReport(true)
	const [ready, setReady] = useState(false)
	const { mutateAsync: createReport } = useCreateReport()
	const { id: reportId } = useParams("/report/:id")
	const [authState, setAuthState] = useState<
		"initial" | "parsing_query" | "creating_report" | "loading_report" | "loaded"
	>("initial")

	React.useEffect(() => {
		setAuth(tryToTruncateUnusedReports(auth))
	}, [])
	useEffect(() => {
		const authFlow = async () => {
			switch (authState) {
				case "initial": {
					return setAuthState("parsing_query")
				}
				case "parsing_query": {
					const params = new URLSearchParams(window.location.search)
					const key = params.get("key")

					if (reportId) {
						setCurrentReportId(reportId)
					}
					if (key) {
						setKey(reportId, key)

						params.delete("key")
						const newUrl = `${window.location.pathname}${
							params.toString() ? `?${params.toString()}` : ""
						}`
						navigate(newUrl as Path)
					}
					return setAuthState("loading_report")
				}
				case "loading_report": {
					const res = await fetchReport()
					if (res.isError) {
						console.error("error loading report", res.error)
						return setAuthState("creating_report")
					}
					return setAuthState("loaded")
				}
				case "creating_report": {
					const newAuth = await createReport()
					setKey(newAuth.id, newAuth.key)
					setCurrentReportId(newAuth.id)

					return setAuthState("loading_report")
				}
				case "loaded": {
					return
				}
			}
		}
		authFlow()
	}, [authState])

	return (
		<APIProvider libraries={["places"]} apiKey={env.VITE_GOOGLE_MAPS_KEY}>
			<Suspense fallback={<p>Loading...</p>}>
				{authState === "loaded" ? <Outlet /> : <LoadingScreen />}
			</Suspense>
		</APIProvider>
	)
}
